import { makeAutoObservable, reaction, runInAction } from "mobx";
import agent from "../api/agent";
import { IStation } from "../models/asset";
import { IServerError } from "../models/serverError";

export default class CommonStore {
    error: IServerError | null = null;
    token: string | null = window.localStorage.getItem('jwt');
    appLoaded = false;
    titlePage: string | null = null;
    stationIdQuery: number | null = null

    loadingStation = false;
    selectedStation: IStation | null = null;
    dropdownStation: IStation[] = [];

    constructor() {
        makeAutoObservable(this);

        reaction(
            () => this.token,
            (token) => {
                if (token) {
                    window.localStorage.setItem('jwt', token);
                } else {
                    window.localStorage.removeItem('jwt');
                }
            }
        );

        reaction(
            () => this.selectedStation,
            (selectedStation) => {
                if (selectedStation) {
                    window.localStorage.setItem('stationId', selectedStation.id.toString());
                } else {
                    window.localStorage.removeItem('stationId');
                }
            }
        );

        reaction(
            () => [this.stationIdQuery, this.dropdownStation],
            (args) => {
                const stationId = args[0] as number
                if (args[0]) {
                    this.setSelectedStation(stationId)
                }
            }
        )
    }

    setServerError = (err: IServerError) => {
        this.error = err;
    }

    setToken = (token: string | null) => {
        this.token = token;
    }

    setAppLoaded = () => {
        this.appLoaded = true;
    }

    setTitlePage = (titlePage: string | null, titleTab?: string | null) => {
        const project_app = 'Rekadia ';
        if (titleTab) {
            document.title = project_app + ' | ' + titleTab;
        } else {
            titlePage ? document.title = project_app + ' | ' + titlePage : document.title = project_app;
        }
        this.titlePage = titlePage;
    }

    setSelectedStation = (stationId: number) => {
        this.selectedStation = this.dropdownStation.find(x => x.id === stationId) ?? null;
    }

    getStations = async () => {
        this.loadingStation = true;
        try {
            // ambil data dropdown station nya dulu
            const stations = await agent.Asset.getStations();

            // set station yg dipilih dari local storage
            runInAction(() => {
                this.dropdownStation = stations;
                this.selectedStation = this.dropdownStation.find(x =>
                    (x.id === parseInt(window.localStorage.getItem('stationId') ?? "0")) ||
                    (x.name === process.env.REACT_APP_DEFAULT_STATION)
                ) ?? null;
            })
        } catch (error) {
            throw error;
        } finally {
            runInAction(() => {
                this.loadingStation = false;
            })
        }
    }

    setStationIdQuery = () => {
        const stationId = new URLSearchParams(window.location.search).get('stationId')
        this.stationIdQuery = stationId ? Number(stationId) : null
    }
}